import { TableRowActionsModel } from "./list.interface";

const noActions: TableRowActionsModel = {
    edit: false,
    delete: false,
    view: false,
    download: false,
    verify: false,
    add: false,
    cancel: false,
    refresh: false,
    mail: false,
    approve: false,
    reject: false,
    deny: false,
    schedule: false,
    select: false,
    history: false,
    return: false,
    viewCDR: false,
    viewPdf: false,
    viewClaimReport: false,
    viewPayment: false,
    viewHierarchy: false,
    showChanges: false,
    unmask: false,
    viewTimesheets: false,
    adjustService: false,
    adjustMCO: false,
    viewLatest: false
}

export class TableRowActions {
    edit  = false;
    delete  = false;
    view  = false;
    download  = false;
    verify = false;
    add = false;
    cancel = false;
    refresh = false;
    mail = false;
    deny = false;
    approve = false;
    reject = false;
    schedule = false;
    select = false;
    history= false;
    return = false;
    viewCDR = false;
    viewHierarchy = false;
    viewPdf = false;
    viewClaimReport = false;
    viewPayment = false;
    showChanges: boolean;
    unmask = false;
    adjustService = false;
    adjustMCO = false;
    viewTimesheets = false;
    viewLatest = false;
    constructor(actions?: Partial<TableRowActionsModel>) {
        let newActions = { ...noActions }
        if (actions) newActions = { ...newActions, ...actions };

        this.edit = newActions.edit;
        this.delete = newActions.delete;
        this.view = newActions.view;
        this.download = newActions.download;
        this.verify = newActions.verify;
        this.add = newActions.add;
        this.cancel = newActions.cancel;
        this.refresh = newActions.refresh;
        this.mail = newActions.mail;
        this.approve = newActions.approve;
        this.reject = newActions.reject;
        this.deny = newActions.deny;
        this.schedule = newActions.schedule;
        this.select = newActions.select;
        this.viewCDR = newActions.viewCDR;
        this.viewHierarchy = newActions.viewHierarchy;
        this.viewPdf = newActions.viewPdf;
        this.viewPayment = newActions.viewPayment;
        this.viewClaimReport = newActions.viewClaimReport;
        this.history=newActions.history;
        this.return = newActions.return;
        this.showChanges=newActions.showChanges;
        this.unmask = newActions.unmask;
        this.viewTimesheets = newActions.viewTimesheets;
        this.adjustMCO = newActions.adjustMCO;
        this.adjustService = newActions.adjustService;
        this.viewLatest = newActions.viewLatest;
    }
}